// Generated unlisted policy metadata, without body text.
export const appPolicies = [
  {
    "slug": "hoboken-sailing-privacy-policy",
    "title": "Privacy Policy for the Hoboken Sailing App",
    "description": "Privacy Policy for the Hoboken Sailing App as originally published.",
    "unlisted": true,
    "source": "https://karalewich.com/hoboken-sailing-privacy-policy/"
  },
  {
    "slug": "river-vale-streets-privacy-policy",
    "title": "River Vale Streets Privacy Policy",
    "description": "River Vale Streets Privacy Policy as originally published.",
    "unlisted": true,
    "source": "https://karalewich.com/river-vale-streets-privacy-policy/"
  },
  {
    "slug": "codes-private-policy",
    "title": "Privacy Policy for Ramsey Rescue App and other CODES Software",
    "description": "Privacy Policy for Ramsey Rescue App and other CODES Software as originally published.",
    "unlisted": true,
    "source": "https://karalewich.com/codes-private-policy/"
  }
];
